var render = function render(){var _vm=this,_c=_vm._self._c;return _c('NuxtLink',{staticClass:"promo-deck",attrs:{"to":_vm.href},nativeOn:{"click":function($event){return _vm.trackEvent('hero', 'click_'+_vm.name)}}},[_c('picture',_vm._g({},_vm.$listeners),[_c('img',{staticClass:"hero-image",attrs:{"src":_vm.image,"alt":"","data-not-lazy":"","height":"174","width":"313"}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }